import { http, HttpResponse } from 'msw'

import { allServiceReports } from 'app/mocks/data/reports/service'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'

import { ServicesReportsRequest } from 'app/types/reports/service'

export const getAllServiceReports = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.service.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allServiceReports.length > limit
                ? offset + limit
                : allServiceReports.length

        const results = allServiceReports.slice(offset, limitArray)

        const next =
            offset + results.length < allServiceReports.length
                ? 'again'
                : undefined

        return HttpResponse.json<ServicesReportsRequest>({
            next,
            results,
        })
    },
)
